<template>
    <div class="def-table-size">
        <table>
            <tr>
                <th>Розмір</th>
                <th>Окружність пальця, мм</th>
            </tr>
            <tr>
                <td>15</td>
                <td>46.5</td>
            </tr>
            <tr>
                <td>15.5</td>
                <td>47.8</td>
            </tr>
            <tr>
                <td>16</td>
                <td>50.3</td>
            </tr>
            <tr>
                <td>16.5</td>
                <td>51.5</td>
            </tr>
            <tr>
                <td>17</td>
                <td>52.8</td>
            </tr>
            <tr>
                <td>17</td>
                <td>52.8</td>
            </tr>
            <tr>
                <td>17.5</td>
                <td>55.3</td>
            </tr>
            <tr>
                <td>18</td>
                <td>56.6</td>
            </tr>
            <tr>
                <td>18.5</td>
                <td>57.8</td>
            </tr>
            <tr>
                <td>19</td>
                <td>59.1</td>
            </tr>
            <tr>
                <td>19.5</td>
                <td>60.3</td>
            </tr>
            <tr>
                <td>20</td>
                <td>61.6</td>
            </tr>
            <tr>
                <td>20.5</td>
                <td>64.1</td>
            </tr>
            <tr>
                <td>21</td>
                <td>65.3</td>
            </tr>
            <tr>
                <td>21.5</td>
                <td>67.5</td>
            </tr>
            <tr>
                <td>22</td>
                <td>69.1</td>
            </tr>

        </table>
        <div style="background-image: url('/local/templates/love-you/images/front-end/blog/blog-5.png')" class="def-table-size__image">
            1
        </div>
    </div>
</template>

<script>
    export default {
        name: 'def-table-size',
        selector: '.def-table-size'
    }
</script>

<style lang="scss">
    .def-table-size{
        display: flex;
        flex-direction: column;
        font-weight: 500;
        font-size: rem(16);
        line-height: 110%;
        color: var(--text-colour-primary);
        text-align: center;
        @include point-md{
            flex-direction: row;
        }
        &__image{
            flex-grow: 1;
            color: transparent;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            height: 320px;
            @include point-md{
                height: auto;
            }
        }
        table{
            border-collapse: separate; /* Способ отображения границы */
            border-spacing: 2px;
            width: 100%;
            margin-bottom: 16px;
            @include point-md{
                max-width: 442px;
                margin-right: 24px;
                margin-bottom: 0;
            }
            @include point-md{
                margin-right: 32px;
            }
        }
        th{
            padding: 14px;
            background: #B8D9EC;
            width: 50%;
        }
        td{
            padding: 11px;
            width: 50%;
            background: #fff;
        }
    }
</style>